module.exports = __webpack_public_path__ + "components/templates/images/assets_library_info/2.png";